<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.reopenCase.reopenCase | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.reopenCase.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <p class="body2 bottom-margin">{{ data.sysText.reopenCase.reopenCaseMessage1 }}</p>
  <p class="body2 bottom-margin">{{ data.sysText.reopenCase.reopenCaseMessage2 }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.rcdata.caseHasEmployee && data.rcdata.showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.reopenCase.reopenCase_sendNotification">
      </app-slide-toggle>
    </div>
  }

  @let isSubmitting = isSubmitting$ | async;
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="cancel()">
        {{ data.sysText.reopenCase.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.reopenCase.submitting_ariaLabel : null"
      (click)="!isSubmitting && reopenCase()">
      {{ data.sysText.reopenCase.reopenCase }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>